module.exports = __webpack_public_path__ + "static/BigOne-973d02e6cff6a9148852d0da1e4f6dac.png";